import { Address } from '@lmc/ts-common'

type MinimumAddress = Pick<
  Address,
  'street1' | 'street2' | 'suburb' | 'state' | 'postcode'
> &
  Partial<Pick<Address, 'name'>>

export const getAddressString = (
  address: MinimumAddress | null | undefined
): string | undefined => {
  if (!address) {
    return undefined
  }

  const addressArray = [
    address.name,
    address.street1,
    address.street2,
    address.suburb,
    address.state,
    address.postcode
  ]
  const addressString = addressArray
    .filter((addressField) => addressField)
    .join(', ')

  return addressString
}
